export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  FATAL = 'fatal',
}

export const LogLevelPriority: Record<LogLevel, number> = {
  [LogLevel.TRACE]: 10,
  [LogLevel.DEBUG]: 20,
  [LogLevel.INFO]: 30,
  [LogLevel.WARN]: 40,
  [LogLevel.ERROR]: 50,
  [LogLevel.FATAL]: 60,
};

export const PriorityToLogLevelMap: Record<number, LogLevel> = {
  [LogLevelPriority[LogLevel.TRACE]]: LogLevel.TRACE,
  [LogLevelPriority[LogLevel.DEBUG]]: LogLevel.DEBUG,
  [LogLevelPriority[LogLevel.INFO]]: LogLevel.INFO,
  [LogLevelPriority[LogLevel.WARN]]: LogLevel.WARN,
  [LogLevelPriority[LogLevel.ERROR]]: LogLevel.ERROR,
  [LogLevelPriority[LogLevel.FATAL]]: LogLevel.FATAL,
};
